import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const Testimonial = ({ id }) => {
  const [TestimonialsList, setTestimonialsList] = useState([]);
  const fetchData = async () => {
    try {
      const list = await corefetch(
        `Testimonial/GetTestimonialListForFacility?facilityID=${id}`
      );
      if (list && list.length > 0) {
        setTestimonialsList(list);
      } else {
        setTestimonialsList([]);
        console.error("No data found");
      }
    } catch (error) {
      setTestimonialsList([]);
      console.error("Error fetching list:", error);
    }
  };
  
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (TestimonialsList?.length) {
      if ($(".wpo-testimonial-wrap").length) {
        $(".slider-for").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: ".slider-nav",
          dots: false,
          autoplay: true,
          autoplaySpeed: 3000,
          responsive: [
            {
              breakpoint: 1231,
              settings: {
                dots: false,
              },
            },
          ],
        });
        $(".slider-nav").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          asNavFor: ".slider-for",
          focusOnSelect: true,
          arrows: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 3000,
          responsive: [
            {
              breakpoint: 1231,
              settings: {
                dots: false,
              },
            },
          ],
        });
      }
    }
  }, [JSON.stringify(TestimonialsList)]);

  if (!TestimonialsList || TestimonialsList.length == 0) {
    return null;
  }

  return (
    <section className="wpo-testimonial-section section-padding ">
      <div className="container">
        <div className="wpo-testimonial-wrap">
          <div className="row align-items-center">
            <div className="col col-md-5">
              <div className="slider-for">
                {TestimonialsList?.map((testimonial, index) => (
                  <div className="testimonial-img" key={index}>
                    <a
                      href={testimonial.galleryURL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={`${ImageURL}${testimonial.imagePath}`}
                        alt={`testimonial-${index}`}
                        style={{
                          width: "100%", // Adjusts the image width to fit the container
                          height: "381px", // Sets a fixed height for the image
                          objectFit: "cover", // Ensures the image covers the area without distortion
                          cursor: "pointer", // Makes it clear that the image is clickable
                        }}
                      />
                    </a>
                  </div>
                ))}
              </div>
            </div>

            <div className="col col-md-7">
              <div className="wpo-testimonial-items">
                <div className="slider-nav">
                  {TestimonialsList?.map((testimonial, index) => (
                    <div className="wpo-testimonial-item" key={index}>
                      <div className="wpo-testimonial-text">
                        <h2 style={{ paddingBottom: 10 }}>
                          {testimonial.title}
                        </h2>
                        <p>{testimonial.description}</p>
                        <div className="wpo-testimonial-text-btm">
                          <h3>{testimonial.clientName}</h3>
                          <span className="review-source">
                            {testimonial.ballroomName} -{" "}
                          </span>
                          <span>
                            {new Date(testimonial.eventDate)
                              .toLocaleDateString("en-US", {
                                month: "short",
                                day: "2-digit",
                                year: "numeric",
                              })
                              .toUpperCase()}
                          </span>{" "}
                          <span className="review-source">
                            {" "}
                            - {testimonial.reviewsFrom}
                          </span>
                        </div>
                        <div style={{ marginTop: "15px" }}>
                          <a
                            href={testimonial.galleryURL}
                            className="theme-btn"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Gallery
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
